.fix_overflow * {
  // overflow: hidden !important;
  text-decoration: none !important;
  text-overflow: initial !important;
  list-style-type: none;
}

.fix_overflow {
  ul, ol {
    list-style-type: none;
  }
}

.fix_overflow *:visited {
  text-decoration: none;
}

